import { createSlice } from "@reduxjs/toolkit";
import {
    createParentForSchool,
    deleteParentData,
    editParentData,
    getParentData,
    getParentsForSchool,
    sendNotificationToParentsService
} from "../services/parents_service";
// ----------------------------------------------------------------------


const slice = createSlice({
    name: "parents",

    initialState: {
        isLoadingSchoolParents: false,
        isLoadingCreateParent: false,
        isLoadingDeleteParentData: false,
        parents: [],
        newParentInfo: {},
        selectedParent: {},
        allParentsData: {},
        isLoadingEditParentData: false,
        isLoadingGetParentData: false,
        isLoading:false,
        parentData: {},
        parentPageNumber: 1,
    },

    reducers: {
        setSelectedParent: (state, action) => {
            state.selectedParent = action.payload
        },
        setParentPageNumber: (state, action) => {
            state.parentPageNumber = action.payload
        }
    },


    extraReducers: {
        //GET  ==> get ParentsForSchool
        [getParentsForSchool.fulfilled]: (state, action) => {
            state.isLoadingSchoolParents = false;
            state.allParentsData = action.payload.data
        },
        [getParentsForSchool.rejected]: (state, action) => {
            state.isLoadingSchoolParents = false;
        },
        [getParentsForSchool.pending]: (state) => {
            state.isLoadingSchoolParents = true;
        },

        //Post  ==> create Parent For School
        [createParentForSchool.fulfilled]: (state, action) => {
            state.isLoadingCreateParent = false;
            state.newParentInfo = action.payload.data
            if (action.payload.message === 'Data created successfully') {
                window.location.href = '/dashboard/families'
            }
        },
        [createParentForSchool.rejected]: (state, action) => {
            state.isLoadingCreateParent = false;
        },
        [createParentForSchool.pending]: (state) => {
            state.isLoadingCreateParent = true;
        },

        //Delete  ==> deleteParentData
        [deleteParentData.fulfilled]: (state, action) => {
            state.isLoadingDeleteParentData = false;
            if (action.payload.message === 'Deleted Successfully'
                || action.payload.message === 'تم الحذف بنجاح'
            ) {
                window.location.reload();
            }
        },
        [deleteParentData.rejected]: (state, action) => {
            state.isLoadingDeleteParentData = false;
        },
        [deleteParentData.pending]: (state) => {
            state.isLoadingDeleteParentData = true;
        },


        //PUT  ==> editParentData
        [editParentData.fulfilled]: (state, action) => {
            state.isLoadingEditParentData = false;
            // if (action.payload.message === 'Deleted Successfully'
            //     || action.payload.message === 'تم الحذف بنجاح'
            // ) {
            //     window.location.reload();
            // }
        },
        [editParentData.rejected]: (state, action) => {
            state.isLoadingEditParentData = false;
        },
        [editParentData.pending]: (state) => {
            state.isLoadingEditParentData = true;
        },

        // Get ==> get Parent Data
        [getParentData.fulfilled]: (state, action) => {
            state.isLoadingGetParentData = false;
            state.parentData = action.payload.data
            // if (action.payload.message === 'Deleted Successfully'
            //     || action.payload.message === 'تم الحذف بنجاح'
            // ) {
            //     window.location.reload();
            // }
        },
        [getParentData.rejected]: (state, action) => {
            state.isLoadingGetParentData = false;
        },
        [getParentData.pending]: (state) => {
            state.isLoadingGetParentData = true;
        },

         // Get ==> get Parent Data
        [sendNotificationToParentsService.fulfilled]: (state, action) => {
            state.isLoading = false;
           
        
        },
        [sendNotificationToParentsService.rejected]: (state, action) => {
            state.isLoading = false;
        },
        [sendNotificationToParentsService.pending]: (state) => {
            state.isLoading = true;
        },


    },

});

// Reducer
export default slice.reducer;

// Actions
export const { setSelectedParent, setParentPageNumber } = slice.actions;